import { StyleSheet } from 'react-native';

import { Fonts } from 'assets/fonts';

import { lightGrey, whiteTransparent } from 'utils/colors';

const styles = StyleSheet.create({
    textInputContainer: {
        flexDirection: 'row',
        height: 32,
        alignItems: 'center',
        justifyContent: 'space-between',
        borderRadius: 4,
        backgroundColor: whiteTransparent(0.1),
        // @ts-ignore
        cursor: 'text',
    },
    searchIconSvgStyle: {
        marginLeft: 12,
        marginRight: 10,
        width: 20,
        height: 20,
    },
    inputContainer: {
        flex: 1,
        height: 32,
    },
    textInput: {
        flex: 1,
        color: lightGrey(),
        fontSize: 16,
        fontWeight: '400',
        fontFamily: Fonts.main.regular,
        padding: 0,
    },
    closeIconSvgStyle: { marginHorizontal: 8 },
    closeIcon: {
        width: 16,
        height: 16,
    },
    searchInputLeftControls: {
        flex: 1,
        flexDirection: 'row',
        alignItems: 'center',
    },
});

export default styles;
